module.exports = __webpack_public_path__ + "static/media/th.16d566c5.svg";